export const scrollToMonthGrid = () => {
  document.getElementById('month-grid').scrollIntoView({ behavior: 'smooth' });
};
